import { type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import Empty from '@fastnorth/kraken/components/empty';
import { Flex } from '@fastnorth/kraken/components/layout';
import RaceSelector from '../../../components/race-selector/RaceSelector';
import PostVirtualResult from './details/components/post-results/PostVirtualResult.tsx';
import { useShouldShowPostButton } from './details/components/post-results/hooks/useShouldShowPostButton.ts';

const LeaderboardEmptyState = (): ReactElement => {
  const { t } = useTranslation('translation', { keyPrefix: 'karwa.event.race.results' });
  const shouldShowPostActivityButton = useShouldShowPostButton();
  return (
    <Flex className="flex-col">
      <Flex className="w-full justify-between flex-wrap items-center" gap={'6'}>
        <RaceSelector path={'/leaderboard'} />
        {shouldShowPostActivityButton && <PostVirtualResult />}
      </Flex>
      <Flex className="w-full" spacing={'7 0'}>
        <Empty
          id={'leaderboard-empty-state'}
          heading={t('empty_state.heading')}
          description={t('empty_state.description')}
          image={{
            src: 'https://cdn.raceroster.com/assets/cerbicons/empty-race-results.svg',
            alt: t('empty_state.image_alt_text'),
            variant: 'illustration',
          }}
        />
      </Flex>
    </Flex>
  );
};

export default LeaderboardEmptyState;
